import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledPreviewMessageContainer = styled(Grid) `
	width: 100%;
	padding: ${Magnetic.spacer24};
`;
export const StyledFirstText = styled.div `
	color: ${Magnetic.colorWhite};
	font-size: ${Magnetic.fontSize16};
	font-weight: ${Magnetic.fontWeightSemibold};
	line-height: normal;
`;
export const StyledPreviewInput = styled.input `
	width: 88%;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: ${Magnetic.spacer12};
	border-radius: ${Magnetic.spacer04};
	font-size: ${Magnetic.fontSize16};
	font-weight: ${Magnetic.fontWeightSemibold};
	margin: ${Magnetic.spacer12} auto;
	margin-bottom: ${Magnetic.spacer32};
`;
export const StyledPhotoPreviewContainer = styled(Grid) `
	background-color: ${Magnetic.colorBlack};
	position: relative;
	padding-bottom: ${Magnetic.spacer20};
	display: flex;
	flex-direction: column;
	height: 100vh;
`;
//# sourceMappingURL=IntelligentPhotoCapturePhotoPreviewPage.style.js.map